import styled from "styled-components";
import { BaseModalContainer } from "../modals.styled";

export const ModalContainer = styled(BaseModalContainer)`
    color: ${(props) => props.theme.colors.neutral[800]};
`;

export const Container = styled.div`
    display: flex;
    flex-flow: column;
    padding: 1rem;
    max-height: calc(100% - 4rem);
`;

export const PropertyRowsContainer = styled.div`
    display: flex;
    flex-flow: column;
    gap: 0.5rem;
    overflow: auto;
    height: 100%;
`;

export const StyledPropertyCard = styled.div`
    display: flex;
    align-items: center;

    height: 3rem;
    border-radius: 0.2rem;
    background: white;
`;

export const AddPropertyCard = styled(StyledPropertyCard)`
    justify-content: center;
    gap: 0.5rem;

    height: 3rem;

    cursor: pointer;

    font-weight: ${(props) => props.theme.fontWeight.bolder};
    font-size: 0.9rem;

    color: white;
    background: ${(props) => props.theme.colors.primary[200]};

    &:hover {
        background: ${(props) => props.theme.colors.primary[400]};
    }

    & > *:last-child {
        font-size: 1.2rem;
    }
`;

const IconBox = styled.div`
    display: grid;
    place-items: center;
    height: 3rem;
`;

export const DragHandle = styled(IconBox)`
    width: 1.8rem;
    border-right: solid 1px ${(props) => props.theme.colors.neutral[100]};
    color: ${(props) => props.theme.colors.neutral[300]};
`;

export const EditBox = styled(IconBox)`
    width: 3rem;
    border-left: solid 1px ${(props) => props.theme.colors.neutral[100]};
    font-size: 1.2rem;
    cursor: pointer;
    color: ${(props) => props.theme.colors.primary[100]};

    &:hover {
        color: ${(props) => props.theme.colors.primary[500]};
    }
`;

export const TrashBox = styled(EditBox)`
    color: ${(props) => props.theme.colors.danger[300]};

    &:hover {
        color: ${(props) => props.theme.colors.danger[500]};
    }
`;

export const InfoIconBox = styled(EditBox)`
    border-left: none;
    border-right: solid 1px ${(props) => props.theme.colors.neutral[100]};

    cursor: default;

    color: ${(props) => props.theme.colors.neutral[300]};

    &:hover {
        color: ${(props) => props.theme.colors.neutral[300]};
    }
`;

export const InfoContainer = styled.div`
    display: flex;
    flex: 1;
    padding: 0 1rem;
    gap: 0.5rem;
    align-items: center;
`;
